module.exports = __webpack_public_path__ + "img/i_maternalAndInfant.4e962a8e.png";